export default function Benchmarking() {
  const globalModels = [
    { element: 'الهدف الرئيسي', weWork: 'مساحة عمل مرنة تجارية', impactHub: 'أثر اجتماعي وتمكين', whiteSpace: 'مساحة مهنية مرنة', zinc: 'منصة دعم شامل لرواد الأعمال' },
    { element: 'الفئة المستهدفة', weWork: 'محترفون وشركات', impactHub: 'رواد اجتماعيون ومشاريع ذات أثر', whiteSpace: 'مستقلون وشركات صغيرة ومتوسطة', zinc: 'رواد أعمال، طلاب، مشاريع ناشئة' },
    { element: 'التمويل والنموذج', weWork: 'ربحي', impactHub: 'شراكات* ومنح', whiteSpace: 'تجاري محلي', zinc: 'تابع لشركة كبرى + دعم مؤسسي' },
    { element: 'الدعم التطويري', weWork: 'محدود', impactHub: 'برامج تطوير ومجتمع', whiteSpace: 'مستوى متوسط (ورش محلية)', zinc: 'دعم شامل + مرشدين + فعاليات' },
    { element: 'الاستدامة المالية', weWork: 'قوي تجاريًا', impactHub: 'تحدي اعتماد على التمويل', whiteSpace: 'تجاري محلي', zinc: 'مدعوم بشركة اتصالات' },
    { element: 'الربط بالشبكات', weWork: 'عالمي', impactHub: 'عالمي', whiteSpace: 'محلي', zinc: 'محلي / إقليمي' },
    { element: 'التركيز على الابتكار', weWork: 'أقل تركيز على الابتكار', impactHub: 'عالي', whiteSpace: 'يعتمد على المجتمع', zinc: 'عالي — منصة ابتكار' }
  ];

  const localModels = [
    { element: 'المرونة', traditional: 'منخفضة', incubators: 'متوسطة', proposed: 'عالية' },
    { element: 'الاستدامة', traditional: 'ضعيفة', incubators: 'محدودة', proposed: 'مدعومة' },
    { element: 'الوصول للطلاب', traditional: 'محدود', incubators: 'انتقائي', proposed: 'واسع' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Global Models */}
        <div className="mb-16">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              المقارنة المرجعية (Benchmarking Analysis)
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              ما بين نماذج محلية وعربية وعالمية
            </p>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block max-w-7xl mx-auto bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-xl overflow-x-auto">
            <div className="grid grid-cols-5 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] text-white min-w-[1000px]">
              <div className="p-6 text-center font-bold text-lg border-l border-white/20">البند</div>
              <div className="p-6 text-center font-bold text-lg border-l border-white/20">WeWork</div>
              <div className="p-6 text-center font-bold text-lg border-l border-white/20">Impact Hub</div>
              <div className="p-6 text-center font-bold text-lg border-l border-white/20">White Space - السعودية</div>
              <div className="p-6 text-center font-bold text-lg">Zain Innovation Campus – ZINC - الأردن</div>
            </div>
            {globalModels.map((row, index) => (
              <div key={index} className={`grid grid-cols-5 min-w-[1000px] ${index !== globalModels.length - 1 ? 'border-b border-gray-200' : ''}`}>
                <div className="p-6 text-center font-semibold text-gray-900 border-l border-gray-200 bg-gray-50">{row.element}</div>
                <div className="p-6 text-center text-gray-700 border-l border-gray-200">{row.weWork}</div>
                <div className="p-6 text-center text-gray-700 border-l border-gray-200">{row.impactHub}</div>
                <div className="p-6 text-center text-gray-700 border-l border-gray-200">{row.whiteSpace}</div>
                <div className="p-6 text-center text-gray-700">{row.zinc}</div>
              </div>
            ))}
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {globalModels.map((row, index) => (
              <div key={index} className="bg-white rounded-2xl border border-gray-200 shadow-md overflow-hidden">
                <div className="bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] px-4 py-3">
                  <p className="font-bold text-white text-base">{row.element}</p>
                </div>
                <div className="divide-y divide-gray-100">
                  {[
                    { label: 'WeWork', value: row.weWork },
                    { label: 'Impact Hub', value: row.impactHub },
                    { label: 'White Space', value: row.whiteSpace },
                    { label: 'ZINC – الأردن', value: row.zinc },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-3 px-4 py-3">
                      <span className="text-xs font-bold text-[#FF6B6B] bg-[#FF6B6B]/10 px-2 py-1 rounded-full flex-shrink-0 mt-0.5">{item.label}</span>
                      <span className="text-sm text-gray-700">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Local Models */}
        <div className="mb-16">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              المقارنة المرجعية - نماذج محلية
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              مقارنة المشروع مع النماذج المحلية الموجودة
            </p>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block max-w-6xl mx-auto bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-xl">
            <div className="grid grid-cols-4 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
              <div className="p-6 text-center font-bold text-lg border-l border-white/20">العنصر</div>
              <div className="p-6 text-center font-bold text-lg border-l border-white/20">مساحات تقليدية</div>
              <div className="p-6 text-center font-bold text-lg border-l border-white/20">حاضنات</div>
              <div className="p-6 text-center font-bold text-lg">مساحة الشباب ✨</div>
            </div>
            {localModels.map((row, index) => (
              <div key={index} className={`grid grid-cols-4 ${index !== localModels.length - 1 ? 'border-b border-gray-200' : ''}`}>
                <div className="p-6 text-center font-semibold text-gray-900 border-l border-gray-200 bg-gray-50">{row.element}</div>
                <div className="p-6 text-center text-gray-700 border-l border-gray-200">{row.traditional}</div>
                <div className="p-6 text-center text-gray-700 border-l border-gray-200">{row.incubators}</div>
                <div className="p-6 text-center font-semibold text-[#FF6B6B]">{row.proposed}</div>
              </div>
            ))}
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {localModels.map((row, index) => (
              <div key={index} className="bg-white rounded-2xl border border-gray-200 shadow-md overflow-hidden">
                <div className="bg-gradient-to-r from-gray-900 to-gray-800 px-4 py-3">
                  <p className="font-bold text-white text-base">{row.element}</p>
                </div>
                <div className="divide-y divide-gray-100">
                  <div className="flex items-center gap-3 px-4 py-3">
                    <span className="text-xs font-bold text-gray-500 bg-gray-100 px-2 py-1 rounded-full flex-shrink-0">مساحات تقليدية</span>
                    <span className="text-sm text-gray-700">{row.traditional}</span>
                  </div>
                  <div className="flex items-center gap-3 px-4 py-3">
                    <span className="text-xs font-bold text-gray-500 bg-gray-100 px-2 py-1 rounded-full flex-shrink-0">حاضنات</span>
                    <span className="text-sm text-gray-700">{row.incubators}</span>
                  </div>
                  <div className="flex items-center gap-3 px-4 py-3">
                    <span className="text-xs font-bold text-[#FF6B6B] bg-[#FF6B6B]/10 px-2 py-1 rounded-full flex-shrink-0">مساحة الشباب ✨</span>
                    <span className="text-sm font-semibold text-[#FF6B6B]">{row.proposed}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Conclusion */}
        <div className="text-center">
          <div className="inline-block bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] text-white px-12 py-8 rounded-2xl shadow-2xl">
            <div className="flex items-center justify-center gap-4">
              <i className="ri-trophy-line text-5xl"></i>
              <div className="text-right">
                <h3 className="font-bold text-2xl mb-2">النتيجة</h3>
                <p className="text-xl">المشروع يجمع مزايا النماذج دون عيوبها</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
